import React, { ReactNode, useEffect, useState } from 'react'
import { Modal } from 'src/components/Modal/Modal'
import { Controller, useForm } from 'react-hook-form'
import { useMutation, useQuery } from 'react-query'
import { ApiErrorType, Job, JobLevelType, ListResponseType, ResponseType } from 'src/types'
import { useTranslation } from 'react-i18next'
import { Button, InputField, MultiSelect } from 'src/components/UI'
import { useJobLevels } from '../../hooks'
import { toast } from 'react-toastify'
import { Get, Post } from 'src/apis/apiWithType'
import { useDocuments } from 'src/pages/basic-information/Documents/hooks'
import { Option } from 'react-multi-select-component'
import Loading from 'src/components/Loading'

export const MutateJobLevel = ({ children, record, mode }: { children: ReactNode, record?: JobLevelType, mode: 'edit' | 'add' }) => {


    const { t } = useTranslation()

    const [open, setOpen] = useState<boolean>(false)

    const { data: docsData, isLoading: loadingOfDocument } = useDocuments()

    const { refetch } = useJobLevels()

    const { data: jobsData, isLoading: loaddingOfJobs } = useQuery<ListResponseType<Job>>({
        queryFn: () => Get('/basic-information/job'),
        queryKey: ['GetJobs']
    })

    const { register, formState: { errors }, reset, handleSubmit, setValue, getValues, control, watch } = useForm<{ fa_name: string, en_name: string, documents: string[], jobs: string[] }>()

    const { mutate, isLoading } = useMutation<ResponseType<JobLevelType[]>, ApiErrorType, Partial<JobLevelType>>({
        mutationFn: (data) => record?.id ? Post(`/basic-information/job-levels/update/${record.id}`, { ...data, form: "update_form", documents: data.documents?.map(i => ({ document_id: i })), jobs: data.jobs?.map(i => ({ job_id: i })) }) as any : Post('/basic-information/job-levels/store', { ...data, form: "store_form", documents: data.documents?.map(i => ({ document_id: i })), jobs: data.jobs?.map(i => ({ job_id: i })) }),
        mutationKey: ['SingleJobLevel', record?.id ?? 'Create'],
        onSuccess: (suc) => {
            toast.success(t('AddedSuccessfully'))
            setOpen(false)
            refetch()
        },
        onError: (error) => {
            toast.error(error.data.message)
        }
    })



    // useEffect(() => {
    //     if (record) {
    //         const { en_name, fa_name } = record
    //         reset({ fa_name, en_name })
    //     }
    // }, [record])

    useEffect(() => {
        if (mode == 'add')
            reset()
    }, [open])



    const handleMutateJobLevel = (data: any) => {
        mutate(data)

    }

    const { isLoading:loadingOfDetail} = useQuery<ResponseType<JobLevelType>>({
        queryFn: ({ queryKey }) => Get(`/basic-information/job-levels/show/${queryKey?.[1]}`),
        queryKey: ['GetLevelJob', record?.id],
        enabled:mode=='edit' && !!record?.id  && open,
        onSuccess: (data) => {
            const record = data.details.data
            if (record) {
                const { en_name, fa_name, documents, jobs } = record

                reset({ en_name, fa_name, documents: documents.map(i => i.id), jobs: jobs.map(i => i.id) })
            }
        }
    })



    return (
        <>
            <div className='flex ' onClick={() => setOpen(true)}>
                {children}
            </div>

            <Modal open={open} setOpen={setOpen} title={record?.id ? t('EditJobLevel') : t('AddJobLevel')}>

                {loadingOfDetail &&  <div className='flex flex-row justify-center items-center w-full'><Loading /></div>}

                { (mode=='add' || (mode=='edit' && !loadingOfDetail)) && <form className='flex flex-col gap-4 min-w-64' onSubmit={handleSubmit(handleMutateJobLevel)}>
                    <InputField
                        label={t('faName')}
                        {...register('fa_name', { required: true })}
                    />

                    <InputField
                        label={t('enName')}
                        {...register('en_name', { required: true })}
                    />

                    {docsData?.details?.data?.data ? <div className='flex flex-col gap-2'>
                        <span className='text-sm text-gray-600'>{t('documentsManagement')}</span>
                        <Controller
                            name={'documents'}
                            control={control}
                            render={({ field: { value, onChange } }) =>
                                <MultiSelect
                                    options={docsData?.details?.data?.data?.map(i => ({ label: i.title, value: i.id })) ?? []}
                                    labelledBy=''
                                    value={value?.map(i => ({ value: i, label: docsData?.details?.data?.data.find(f => f.id == i)?.title ?? 'dfg' }))}
                                    onChange={(items: Option[]) => setValue('documents', items.map(i => i.value))}
                                />}

                        /></div> : <div className='flex flex-row justify-center items-center w-full'><Loading /></div>}


                    {jobsData?.details?.data?.data ? <div className='flex flex-col gap-2'>
                        <span className='text-sm text-gray-600'>{t('job')}</span>
                        <Controller
                            name={'jobs'}
                            control={control}
                            render={({ field: { value, onChange } }) =>
                                <MultiSelect
                                    options={jobsData?.details?.data?.data?.map(i => ({ label: i.name, value: i.id })) ?? []}
                                    labelledBy=''
                                    value={value?.map(i => ({ value: i, label: jobsData?.details?.data?.data.find(f => f.id == i)?.name ?? '' }))}
                                    onChange={(items: Option[]) => setValue('jobs', items.map(i => i.value))}
                                />}

                        /></div> : <div className='flex flex-row justify-center items-center w-full'><Loading /></div>}

                    <Button loading={isLoading} keyTitle='save' type='submit' ></Button>



                </form>}

            </Modal>
        </>
    )
}
